import React from 'react';
import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CancelIcon from '@mui/icons-material/Cancel';
import { Tooltip } from '@payer-admin-ui/components-v2/src/utils/Tooltip';

const ClearFiltersButton = ({ disabled, onClick }) => {
  const { t } = useTranslation();

  return (
    <Tooltip inline title={t('filter.clearFilters')}>
      <IconButton sx={{ ml: '5px' }} disabled={disabled} onClick={onClick}>
        <CancelIcon color={!disabled ? 'error' : 'gray'} />
      </IconButton>
    </Tooltip>
  );
};
ClearFiltersButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export { ClearFiltersButton };
